import hotkeys from 'hotkeys-js'
/**
 * im设置功能
 * 设计稿： https://imagecdn.ymm56.com/ymmfile/static/resource/78805b6d-60d2-491e-8a82-cdb8d760f4d3.png
 */
export class ImSetting {
  scene = 'im-layout-setting'
  defaultConfig = {
    openTool: true,
    toolList: [
      // {
      //   buttonName: '客服电话',
      //   commandType: 'syncToRecord',
      //   content: {
      //     bizTypeIds: [90008212, 90047756, 90047758],
      //     remark: '客户索要电话号码'
      //   }
      // },
      // {
      //   buttonName: '无效',
      //   commandType: 'syncToRecord',
      //   content: {
      //     bizTypeIds: [90008212, 90047756, 90047758],
      //     remark: '无效咨询'
      //   }
      // },
      // {
      //   buttonName: '无上下文',
      //   commandType: 'syncToRecord',
      //   content: {
      //     bizTypeIds: [90008212, 90047756, 90047758],
      //     remark: '留言无下文'
      //   }
      // },
      {
        buttonName: '风险单',
        commandType: 'openRiskDialog'
      },
      {
        buttonName: '用户ID',
        commandType: 'copyUserId',
        content: {
          successToast: '复制成功'
        }
      },
      {
        buttonName: '手机号',
        commandType: 'copyTelephone',
        content: {
          successToast: '复制成功'
        }
      }
    ],
    firstReceiveConfig: {
      open: true, // 生效
      label: '首响',
      hotkeysDesc: 'ALT+S',
      replyText: '请您详细的描述您的问题，方便我能快速的解决您的问题😁😁😁'
    },
    todoConfig: {
      open: true, // 生效
      label: '需介入',
      hotkeysDesc: 'ALT+D',
      replyText: '亲稍等，我正在查看你的问题😁😁😁'
    }
  }
  runtimeConfig = {}
  constructor() {
    this.query()
  }
  /**
   * 表单暂存
   * @returns {Promise<void>}
   */
  save(config) {
    try {
      this.runtimeConfig = Object.assign({ ...this.runtimeConfig }, config)
      window.localStorage.setItem(this.scene, JSON.stringify(this.runtimeConfig))
    } catch (e) {
      console.error(e)
    }
  }
  // 获取暂存值
  query() {
    try {
      const configStr = window.localStorage.getItem(this.scene)
      this.runtimeConfig = JSON.parse(configStr) || this.defaultConfig
    } catch (e) {
      console.error(e)
      this.runtimeConfig = this.defaultConfig
    }
  }
  getRuntimeConfig() {
    return this.runtimeConfig
  }
}

export default new ImSetting()
